export const SESSION_TIMEOUT = 'Forgotpwd/SESSION_TIMEOUT'

export const INIT = 'DefaultRegister/INIT'
export const FETCH_DATA_ERROR = 'DefaultRegister/FETCH_DATA_ERROR'
export const FETCH_DATA_SUCCESS = 'DefaultRegister/FETCH_DATA_SUCCESS'

export const REQUEST_RECAPTCHA = 'DefaultRegister/REQUEST_RECAPTCHA'
export const REQUEST_RECAPTCHA_SUCCESS = 'DefaultRegister/REQUEST_RECAPTCHA_SUCCESS'
export const REQUEST_RECAPTCHA_ERROR = 'DefaultRegister/REQUEST_RECAPTCHA_ERROR'

export const REQUEST_APPLICATIONS = 'DefaultRegister/REQUEST_APPLICATIONS'
export const REQUEST_APPLICATIONS_SUCCESS = 'DefaultRegister/REQUEST_APPLICATIONS_SUCCESS'
export const REQUEST_APPLICATIONS_ERROR = 'DefaultRegister/REQUEST_APPLICATIONS_ERROR'

export const SUBMIT_REQUEST = 'DefaultRegister/SUBMIT_REQUEST'
export const SUBMIT_REQUEST_SUCCESS = 'DefaultRegister/SUBMIT_REQUEST_SUCCESS'
export const SUBMIT_REQUEST_ERROR = 'DefaultRegister/SUBMIT_REQUEST_ERROR'

export const REQUEST_PHONE_CODES = 'DefaultRegister/REQUEST_PHONE_CODES'
export const REQUEST_PHONE_CODES_SUCCESS = 'DefaultRegister/REQUEST_PHONE_CODES_SUCCESS'
export const REQUEST_PHONE_CODES_ERROR = 'DefaultRegister/REQUEST_PHONE_CODES_ERROR'

export const CANCEL = 'Forgotpwd/CANCEL'
